<script>
export default {
  props: {
    marginY: {
      type: Number,
      default: 20,
    },
    marginX: {
      type: Number,
      default: 20,
    },
  },
}
</script>

<template>
  <div :class="$style.divider" :style="{ margin: `${marginY}px ${marginX}px` }"></div>
</template>

<style lang="scss" module>
@import '@design';

.divider {
  height: 1px;
  background: $light-gray;
  background: -webkit-gradient(
    linear,
    0 0,
    100% 0,
    from($lightest-gray),
    to($lightest-gray),
    color-stop(50%, $light-gray)
  );
  border: 0;
}
</style>
